// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3gxU5","link":"header-module--link--1yYhn","avatar":"header-module--avatar--1d3le","title":"header-module--title--20euu"};